<template>
  <Quiz></Quiz>
</template>

<script>
// send height to parent whenever document size changes
import { pymChild } from "./utils.js";
const sendChildHeight = () => pymChild.sendHeight();
if ("ResizeObserver" in window) {
  const ro = new ResizeObserver(sendChildHeight);
  ro.observe(document.documentElement);
} else {
  // this should generally be debounced but in this situation it won't matter
  window.addEventListener("resize", sendChildHeight);
}

import Quiz from "./components/Quiz.vue";
import "@/styles/quiz.css";

export default {
  name: "App",
  components: {
    Quiz,
  },
};
</script>

<style lang="css">
:root {
  /* we should put all these colors in slate.css someday */
  --kiwi-hsl: 96.4, 63%, 53.3%;
  --partisan-red-hsl: 0, 65.1%, 50.6%;
}

button {
  font-family: inherit;
}

/* https://v1.tailwindcss.com/docs/screen-readers */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
